import { ActionType, IAction, SurveyMode } from '../types'
import { IOnTryAgain, addOnTryAgainToAction } from './onTryAgain'

export default function errorAction(actionProps: Partial<IAction>, onTryAgain?: IOnTryAgain): IAction {
  const errorAction: IAction = {
    ...actionProps,
    action: ActionType.ERROR,
    mode: actionProps.mode || SurveyMode.RESPONDENT
  }
  if (onTryAgain) {
    addOnTryAgainToAction(errorAction, onTryAgain)
  }
  return errorAction
}
